import React, { useRef, useState } from 'react'
import { Box, withStyles, Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import { SectionPopover } from '../index'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { useDispatch } from 'react-redux'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import { CoreTextField } from 'src/components/core'
import { PatchContent, PatchData } from 'src/model/patch'
import { patchSectionAction } from 'src/reducers/course/action'
import { deleteSectionAction } from 'src/reducers/card/action'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import findNextCardAfterDeletion from 'src/hooks/findNextCardAfterDeletion'
const SectionTextfield = props => {
  const { classes, provided, section, setSections, sections, activeId } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const [openPopup, setOpenPopup] = React.useState(null)
  const [sectionName, setSectionName] = React.useState(section.name)
  const editValueRef = useRef(section.name)

  const handleClosePopup = event => {
    if (event) event.stopPropagation()
    setOpenPopup(null)
  }

  const EditField = () => {
    const [localValue, setLocalValue] = useState(sectionName)

    return (
      <CoreTextField
        label="Section Title"
        value={localValue}
        onChange={e => {
          setLocalValue(e.target.value)
          editValueRef.current = e.target.value
        }}
        fullWidth
      />
    )
  }

  const handleOpenEditPopup = event => {
    editValueRef.current = sectionName

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              e => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Save',
              ButtonActionType.EDIT,
              e => {
                const data = new PatchData(
                  new PatchContent(
                    editValueRef.current,
                    'Name',
                    PatchContent.OPERATION_REPLACE,
                  ),
                  section.id,
                )
                dispatch(patchSectionAction(data))
                setSectionName(editValueRef.current)

                dispatch(messageBoxHideAction())
              },
            ),
          ],
          title: 'Rename Section',
          component: <EditField />,
        }),
      ),
    )
  }
  const handleDeleteSection = sectionId => {
    let newSections = sections
    newSections = newSections.filter(section => section.id !== sectionId)
    setSections(newSections)
    dispatch(deleteSectionAction(sectionId, () => {}))
  }

  const handleDeletePopup = event => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.ERROR,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              e => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Delete',
              ButtonActionType.DELETE,
              e => {
                handleDeleteSection(section.id)
                const nextCard = findNextCardAfterDeletion(
                  section.id,
                  sections,
                  true,
                )
                if (nextCard) {
                  history.push(`${location.pathname}/page/${nextCard.id}`)
                } else {
                  history.push(`${location.pathname}`)
                }
                dispatch(messageBoxHideAction())
              },
            ),
          ],
          title: 'Delete Section',
          note: 'Note: All cards of this section will be deleted as well.',
          description: 'You are about to delete this section. Do you confirm?',
        }),
      ),
    )
  }
  const open = useSelector(state => state.course.sectionDrawerOpen)
  const course = useSelector(state => state.course.course)
  const firstCardOfSection = section.cards[0]?.id

  const onClickSection = () => {
    history.push(`/mini-course/${course.id}/page/${firstCardOfSection}`)
  }
  return (
    <Box
      className={classes.header}
      style={{
        height: open ? '45px' : '0px',
        padding: open ? '8px 4px 8px 8px' : '0px',
        margin: open ? '8px 0px' : '0px',
        overflow: 'hidden',
        transition: 'all 0.225s',
      }}
      onClick={event => {
        event.stopPropagation()
        onClickSection()
      }}
    >
      <span {...provided.dragHandleProps}>
        <Icon
          icon="icon-park-outline:drag"
          className={classes.selectionDragIcon}
        />
      </span>
      <span {...provided.dragHandleProps}>
        <div
          style={{
            width: '195px',
          }}
        >
          {sectionName.length == 0 || sectionName == null ? (
            <Typography className={classes.sectionTitleBase}>
              Section Title
            </Typography>
          ) : (
            <Typography
              style={{
                whiteSpace: 'normal',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontFamily: 'Inter',
                fontSize: '13px',
                fontWeight: 500,
                maxWidth: '185px',
              }}
            >
              {sectionName}
            </Typography>
          )}
        </div>
      </span>

      <div
        style={{
          flexGrow: 1,
        }}
      ></div>
      <Icon
        icon={'eva:more-vertical-fill'}
        className={classes.moreFillIcon}
        onClick={event => {
          event.stopPropagation()
          setOpenPopup(event.currentTarget)
        }}
      />
      <SectionPopover
        openPopup={openPopup}
        handleClosePopup={handleClosePopup}
        itemData={[
          {
            text: 'Rename Section',
            action: event => {
              if (event) event.stopPropagation()
              handleOpenEditPopup()
            },
          },
          {
            text: 'Delete Section',
            action: event => {
              if (event) event.stopPropagation()
              handleDeletePopup()
            },
          },
        ]}
      />
    </Box>
  )
}

export default withStyles(styles)(SectionTextfield)
